import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import withBoundary from 'component/ErrorBoundary/withBoundary';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
export default React.memo(withBoundary(ScrollToTop));
